
import React from 'react';
import SystemStats from '@/components/admin/SystemStats';
import UserManagement from '@/components/admin/UserManagement';
import PricingManagement from '@/components/admin/PricingManagement';

export default function AdminPanel() {
  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Panel</h1>
        <p className="text-gray-600">
          Manage users, subscriptions, and system settings
        </p>
      </div>

      <div className="space-y-8">
        <SystemStats />
        <UserManagement />
        <PricingManagement />
      </div>
    </div>
  );
}
